import React from 'react'

import { makeStyles } from '@material-ui/styles';
import { Typography, Link } from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const useStyles= makeStyles(theme=>({
    root: {
         padding: theme.spacing(4)
    }
}))
export default function Footer(props) {
    const { className, ...rest }= props;
    const classes = useStyles();

    return (
        <div
        {...rest}
        className={clsx(classes.root, className)}
        >
            <Typography variant="body1">
                &copy;{' '}
                <Link
                component="a"
                href=""
                target="_blank"
                >
                    Damodar.K
                </Link> {' '}
                 2025
            </Typography>
            <Typography variant="caption">
               Created with passion
            </Typography>
        </div>
    )
}

Footer.propTypes={
    className: PropTypes.string
}